import request from '@/service/apiConfig/request'

/**
 * 查询用户权限
 */
export const queryAuthority = () => {
  return request.get('/union/member/accountCenter/settlementInvoice/checkUser.htm')
}